import { saveAs } from 'file-saver';
import { SUBUNITS_IN_CURRENCY } from './constants';

export function getValidLanguageCode(language_code: string) {
    return language_code === 'ge' ? 'ka' : language_code;
}

export function getCurrencyInSubUnits(currency: number) {
    return currency * SUBUNITS_IN_CURRENCY;
}

export function getCurrencyBySubUnits(subunits: number) {
    return subunits / SUBUNITS_IN_CURRENCY;
}

export const saveBlobFile = (blob: Blob, fileName: string) => {
    const fileURL = URL.createObjectURL(blob);
    window.open(fileURL, '_blank');
    saveAs(blob, fileName);
};

export function isPositiveNumber(
    amount: number | null | undefined,
): amount is number {
    if (typeof amount !== 'number') {
        return false;
    }

    if (amount > 0) {
        return true;
    }

    return false;
}
